'use client'

import { Radio, RadioGroup } from '@heroui/radio'
import { useState, useEffect } from 'react'
import { useLocale, useTranslations } from 'next-intl'
import { usePathname, useRouter } from '@/i18n/navigation'

type Lang = 'en' | 'ar'

export default function LanguagePage() {
  const router = useRouter()
  const pathname = usePathname()
  const locale = useLocale() as Lang
  const t = useTranslations()
  const [selectedLang, setSelectedLang] = useState<Lang>(locale)

  function changeLanguage(lang: Lang) {
    router.replace(pathname, { locale: lang })
  }

  useEffect(() => {
    if (selectedLang !== locale) {
      changeLanguage(selectedLang)
    }
    document.documentElement.lang = selectedLang
    document.documentElement.dir = selectedLang === 'ar' ? 'rtl' : 'ltr'
  }, [selectedLang])

  return (
    <section className='flex flex-col gap-5'>
      <h1 className='text-3xl font-semibold'>{t('lang.Language')}</h1>
      <div>{t('lang.selectLanguage')}</div>

      <div className='flex flex-col gap-3'>
        <RadioGroup
          orientation='horizontal'
          name='lang'
          value={selectedLang}
          className='text-black-robe text-xl'
          onValueChange={val => setSelectedLang(val as Lang)}
        >
          <Radio
            key='ar'
            color='secondary'
            value='ar'
            classNames={{
              label: 'text-black text-xl',
            }}
          >
            العربية
          </Radio>

          <Radio
            key='en'
            color='secondary'
            value='en'
            classNames={{
              label: 'text-black text-xl',
            }}
          >
            English
          </Radio>
        </RadioGroup>
      </div>
    </section>
  )
}
